'use client';

import { MetamaskIcon, MoonpayIcon, WalletConnectIcon } from '@repo/icons';
import { useTranslations } from 'next-intl';
import React, { memo, useState } from 'react';
import DepositCryptoFormMoonpay from '@/app/[locale]/(account)/account/components/deposit-with-crypto/deposit-crypto-form-moonpay';
import Method from '@/components/common/method-item';
import { PAYMENT_TYPES } from '@/constants';
import { usePaymentMethodsWithNetworks } from '@/hooks/usePaymentMethodsWithNetworks';

const CreditCards = () => {
  const t = useTranslations('deposits');

  const [method, setMethod] = useState<string | null>(null);

  const { providerDetails } = usePaymentMethodsWithNetworks({
    paymentType: PAYMENT_TYPES.DEPOSITS,
  });

  if (method === 'moonpay') {
    return (
      <DepositCryptoFormMoonpay
        className="h-[50vh] md:h-[60dvh]"
        supportedWalletAddresses={providerDetails?.MoonPay?.walletRecords || []}
      />
    );
  }

  return (
    <div className="space-y-2 py-2 animate-in fade-in sm:space-y-4 sm:py-4">
      <div className="flex flex-col space-y-2 text-center vt-text-size-medium vt-headings-text">
        <span>{t('credit-cards-description-1')}</span>
        <span>{t('credit-cards-description-2')}</span>
      </div>

      <div className="flex w-full flex-col space-y-2 sm:flex-row sm:space-x-5 sm:space-y-0 sm:rtl:space-x-reverse">
        <Method
          title="Moonpay"
          icons={[<MoonpayIcon key="MoonpayIcon" />]}
          onClick={() => setMethod('moonpay')}
        />
        <Method
          title="WalletConnect"
          subTitle="Coming Soon"
          icons={[<WalletConnectIcon key="WalletConnectIcon" />]}
          onClick={() => null}
          className="pointer-events-none cursor-not-allowed opacity-50"
        />
        <Method
          title="Metmask"
          subTitle="Coming Soon"
          icons={[<MetamaskIcon key="MetamaskIcon" />]}
          onClick={() => null}
          className="pointer-events-none cursor-not-allowed opacity-50"
        />
      </div>
    </div>
  );
};

export default memo(CreditCards);
